import React from 'react';
import { Card, Button, Typography } from 'antd';
import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Text } = Typography;

const PaymentInfoCard = ({ billingDetails, cardStyle, onAddPaymentMethod, loading }) => {
  const { t } = useTranslation();
  const paymentMethodType = billingDetails?.type ?? null;
  const hasPaymentMethod = Boolean(paymentMethodType);
  const paymentCard = paymentMethodType === 'card' ? billingDetails?.payment_card : null;
  const linkAccount = paymentMethodType === 'link' ? billingDetails?.link_account : null;

  return (
    <Card
      style={{ ...cardStyle, height: '100%' }}
      title={t('payment_information')}
      extra={
        <Button
          type="link"
          icon={hasPaymentMethod ? <EditOutlined /> : <PlusOutlined />}
          color="primary"
          target="_blank"
          loading={loading}
          onClick={onAddPaymentMethod}
        >
          <span className="payment-info-button-text">{hasPaymentMethod ? t('manage') : t('add')}</span>
        </Button>
      }
    >
      {billingDetails && (
        <div>
          {paymentCard ? (
            <div>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 16 }}>
                <Text strong style={{ display: 'block', fontFamily: 'monospace' }}>
                  {paymentCard.brand}
                </Text>
                <div>
                  <Text strong style={{ display: 'block', fontFamily: 'monospace' }}>
                    **** **** **** {paymentCard.last4}
                  </Text>
                  <Text type="secondary">
                    Exp {String(paymentCard.exp_month).padStart(2, '0')}/
                    {String(paymentCard.exp_year).slice(-2)}
                  </Text>
                </div>
              </div>
            </div>
          ) : linkAccount ? (
            <div>
              <Text strong style={{ display: 'block', marginBottom: 4 }}>
                Link
              </Text>
              <Text type="secondary" style={{ display: 'block', marginBottom: 8 }}>
                {linkAccount.email}
              </Text>
            </div>
          ) : (
            <div>
              <Text type="secondary" style={{ display: 'block', marginBottom: 8 }}>
                {t('no_payment_method')}
              </Text>
            </div>
          )}
        </div>
      )}
    </Card>
  );
};

export default PaymentInfoCard; 
